// extracted by mini-css-extract-plugin
export default {"labelEspecial":"PanelInformacionPredio_labelEspecial__6cYIg"};